import React from 'react';

import { resultTitle } from 'src/components/molecules/AddressSearch/styles/styles';

export type ResultTitleProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>;

export const ResultTitle = (props: ResultTitleProps) => (
  <p css={resultTitle} {...props}>
    {props.children}
  </p>
);
